export const getContent = `
  query getContent($path: String!, $draft: Boolean!) {
    getContent(path: $path, draft: $draft) {
      status {
        code
        location
      }
      title {
        title
        seo {
          title
          description
          keywords
          canonical
          ogDescription
          twitterDescription
          image
          language
          allHrefs {
            locale
            path
          }
          globalName {
            locale
            path
          }
          titlePattern
          noIndex
        }
        page {
          placeholders {
            id
            slot
            plugins {
              pluginType
              id
              props
              position
              parent {
                id
              }
            }
          }
          pageOptions{
            headerMenuColor
            secondaryMenu {
              name
              url
              button
              children {
                name
                url
                button
              }
            }
          }
          menu{
           name
           url
           menuStyle
           image
           description
           sizing
           newWindow
           children {
             name
             url
             menuStyle
             image
             description
             sizing
             imageBackgroundColor
             newWindow
             children {
               name
               url
               menuStyle
               image
               description
               sizing
               newWindow
             }
           }
         }
         rightHeaderMenu{
           name
           url
           menuStyle
           image
           description
           sizing
           children {
             name
             url
             menuStyle
             image
             description
             sizing
             imageBackgroundColor
           }
         }
  
         footerMenu{
          name
          url
          menuStyle
          image
          description
          sizing
          newWindow
          children {
            name
            url
            menuStyle
            image
            description
            sizing
            imageBackgroundColor
            newWindow
          }
        }
        countries {
          name
          language
          continent
          languageName
          code
          path
          currencyCode
          storePage
        }
        countrySite {
          path
          phoneNumberSales
          phoneNumberSupport
          facebookUrl
          twitterUrl
          instagramUrl
          youtubeUrl
          linkedinUrl
          language
          regionFlag
          storePage
          defaultCountry {
            currencyCode
            iso
          }
          allowedCountries {
            name
            iso
          }
          notificationBanner {
            endDate
            startDate
            message
          }
        }
        }
      }
    }
  }
`;
